import React from 'react';
import { Input, FormGroup, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import { format as formatDate } from 'date-fns';

import AdminPage from '../hocs/AdminPage';
import firebase from '../../firebase';
import { adminFields, } from '../../shared/models/user';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import EditButton from '../EditButton';

const db = firebase.firestore();

export default AdminPage(function AdminCompanies(props) {
  const { user: operator } = props;
  const users = useCollectionSubscription(db.collection('users').orderBy('email'));
  const onCheck = async (ref, name, checked) => {
    try {
      await ref.update({ [name]: checked, ...(name === 'admin' && !checked && { readOnly: false }) });
    } catch(e) {
      console.error(e);
      toast.error('更新に失敗しました');
    }
  };

  return (
    <div className="admin-users">
      <div className="container-fluid py-5">
        <div className="d-flex justify-content-center mb-2">
          <h3>ユーザー管理</h3>
        </div>
        <table className="table mt-5 table-bordered">
          <thead className="thead-light">
            <tr>
              <th>Email</th>
              <th>ユーザー名</th>
              <th>Admin</th>
              <th>閲覧専用</th>
              <th>勘定奉行クラウド</th>
              <th>登録日時</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              users.map((user) => {
                const { id, ref, email, displayName, admin = false, readOnly = false, createdAt, bugyoEnabled = false, } = user;
                return (
                  <tr key={id} id={id}>
                    <td>
                      {email}
                    </td>
                    <td>
                      {displayName}
                    </td>
                    <td>
                      <FormGroup check>
                        <Label check>
                          <Input type="checkbox" checked={admin} onChange={_ => onCheck(ref, 'admin', _.target.checked)} disabled={operator.id === id} />
                          Admin
                        </Label>
                      </FormGroup>
                    </td>
                    <td>
                      <FormGroup check>
                        <Label check>
                          <Input type="checkbox" checked={readOnly} onChange={_ => onCheck(ref, 'readOnly', _.target.checked)} disabled={!admin || operator.id === id} />
                          閲覧専用
                        </Label>
                      </FormGroup>
                    </td>
                    <td>
                      {bugyoEnabled && '勘定奉行クラウド'}
                    </td>
                    <td>
                      {createdAt != null && formatDate(createdAt.toDate(), 'yyyy/MM/dd HH:mm')}
                    </td>
                    <td>
                      <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: '会社 編集', fields: adminFields, }} />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  );
});
